import React from 'react';
import { FormFieldset } from '@tesla/design-system-react';
import { arrayOf, shape, string } from 'prop-types';
import { FormField } from 'informed';
import formStyle from '../../JobApplicationForm/style.module.scss';
import { useTCLFormApi } from '../../../hooks';

const WorkExperience = ({ fields }) => {
  const { other = [], availability = [] } = fields;
  const formHelper = useTCLFormApi();
  const getFieldSchema = (field) => {
    const { name, schema } = formHelper.field(field);
    return {
      name,
      schema: schema.properties[name],
    };
  };

  return (
    <>
      {fields.resume && (
        <FormFieldset className={formStyle.FormSection}>
          {fields.resume && (
            <div className={`${formStyle.FormFieldHalfWidth}`}>
              <FormField {...formHelper.field(fields.resume)} />
            </div>
          )}
        </FormFieldset>
      )}
      {fields.employers && (
        <FormFieldset className={`${formStyle.FormSection}`}>
          <FormField
            {...formHelper.field(fields.employers)}
            initialValue={[
              {
                companyName: '',
                jobTitle: '',
                startDate: null,
                isCurrent: false,
                endDate: null,
                summaryDuties: '',
              },
            ]}
            max="4"
          />
        </FormFieldset>
      )}
      <FormFieldset
        className={formStyle.FormSection}
        legend={
          fields.essentialJobFunctionLegend
            ? formHelper.field(fields.essentialJobFunctionLegend)?.schema.properties
                .essentialJobFunctionLegend.text
            : ''
        }
        legendProps={fields.essentialJobFunctionLegend ? { looksLike: 'h3' } : ''}
      >
        {other.map((field) => {
          const schemaField = getFieldSchema(field);
          if (schemaField.schema['ui:control'] === 'switch_toggle') {
            return (
              <div className={`${formStyle.FormFieldHalfWidth}`}>
                <div className="tds-form-item">
                  <div className="tds-form-label tds-form-label-wrap">
                    <span className="tds-form-label">
                      <span className="tds-form-label-text">{schemaField.schema.title}</span>
                    </span>
                  </div>
                  <div className="tds-form-input tds-form-input-wrap--switchtoggle">
                    <FormField {...formHelper.field(field)} />
                  </div>
                </div>
              </div>
            );
          }
          return <FormField {...formHelper.field(field)} />;
        })}
      </FormFieldset>
      {fields.availability && (
        <FormFieldset
          className={formStyle.FormSection}
          legend={
            fields.availabilityLegend
              ? formHelper.field(fields.availabilityLegend)?.schema.properties.availabilityLegend
                  .text
              : ''
          }
          legendProps={fields.availabilityLegend ? { looksLike: 'h3' } : ''}
        >
          {availability.map((field) => {
            const schemaField = getFieldSchema(field);
            if (schemaField.schema['ui:control'] === 'switch_toggle') {
              return (
                <div className={`${formStyle.FormFieldHalfWidth}`}>
                  <div className="tds-form-item">
                    <div className="tds-form-label tds-form-label-wrap">
                      <span className="tds-form-label">
                        <span className="tds-form-label-text">{schemaField.schema.title}</span>
                      </span>
                    </div>
                    <div className="tds-form-input tds-form-input-wrap--switchtoggle">
                      <FormField {...formHelper.field(field)} />
                    </div>
                  </div>
                </div>
              );
            }
            return <FormField {...formHelper.field(field)} />;
          })}
        </FormFieldset>
      )}
    </>
  );
};

WorkExperience.propTypes = {
  fields: shape({
    availability: arrayOf(string),
    experience: arrayOf(string),
    other: arrayOf(string),
  }).isRequired,
};

export default WorkExperience;
